import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';

/**
 * Floating "↑ Back to top" button.
 * Appears after the user scrolls past `threshold` pixels (default 400).
 * Smoothly scrolls the window to the top on click.
 */
export const BackToTopButton = ({ threshold = 400 }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > threshold);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Back to top"
      data-testid="back-to-top-btn"
      className="fixed bottom-6 right-6 z-50 w-11 h-11 rounded-full bg-[#36454F] text-[#E0BFB8]
                 shadow-lg hover:bg-[#B76E79] hover:text-white transition-colors duration-200
                 flex items-center justify-center font-['Manrope'] focus:outline-none
                 focus-visible:ring-2 focus-visible:ring-[#B76E79] focus-visible:ring-offset-2
                 animate-fade-in-up"
    >
      <ArrowUp className="w-5 h-5" strokeWidth={2} />
    </button>
  );
};

export default BackToTopButton;
